// DS: i7.7
import React from 'react';
import IconWrap from '../../IconWrap';
const LeftAlign = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M4 6a1 1 0 001 1h9a1 1 0 000-2H5a1 1 0 00-1 1zm1 13h9a1 1 0 000-2H5a1 1 0 000 2zm0-6h14a1 1 0 000-2H5a1 1 0 000 2z"
    })));
};
LeftAlign.displayName = 'LeftAlign';
export default LeftAlign;
